import { useToast } from '@monorepo/shared/contexts/ToastContext';
import { useSyncAnalyticsDataNow } from '@monorepo/shared/hooks/analyticsSync/useSyncAnalyticsDataNow';
import { useModal } from '@monorepo/shared/hooks/useModalV2';
import React, { useCallback } from 'react';
import {
  ESTIMATED_COST_FOR_SYNC_TEXT,
  SCHEDULED_EXTRACTION_TIMING_TEXT,
  TIME_FOR_SYNC_TO_COMPLETE_TEXT,
} from '../consts';

export const useHandleSyncNow = () => {
  const [syncAnalyticsDataNow] = useSyncAnalyticsDataNow({
    config: { throwOnError: true },
  });
  const { confirm } = useModal();
  const { success: showSuccessToast, showUserFriendlyErrorToast } = useToast();

  const handleSyncNow = useCallback(
    async (datasetId: string, organizationId: string) => {
      try {
        const isConfirmed = await confirm({
          title: 'Sync now',
          description: (
            <>
              Are you sure you want to sync now?{' '}
              <b>
                This will cause all EDP data to be synced and will cost
                approximately {ESTIMATED_COST_FOR_SYNC_TEXT}.{' '}
              </b>
              If you are setting up multiple data sources, consider clicking
              &quot;Sync now&quot; after all are set up.
              <br />
              <br />
              Scheduled syncs run at {SCHEDULED_EXTRACTION_TIMING_TEXT}.
            </>
          ),
          confirmButtonText: 'Initiate sync',
          cancelButtonText: 'Cancel',
          danger: true,
          onConfirmAsync: async () => {
            await syncAnalyticsDataNow({
              inputDatasetId: datasetId,
              organizationId,
            });
          },
          afterConfirmButtonText: 'Initiating sync...',
        });
        if (isConfirmed) {
          showSuccessToast(
            `Sync process initiated. Updated data can take up to ${TIME_FOR_SYNC_TO_COMPLETE_TEXT} to finish syncing to Sigma, but may take as little as a couple minutes.`,
            { autoHideDuration: 10 * 1000 },
          );
        }
      } catch (err) {
        showUserFriendlyErrorToast(err, 'Unable to initiate the sync process');
      }
    },
    [
      confirm,
      showUserFriendlyErrorToast,
      showSuccessToast,
      syncAnalyticsDataNow,
    ],
  );
  return handleSyncNow;
};
